import {action, computed, _ } from '@api'
import {TDShape, WhiteboardPage, WhiteboardShape, WhiteboardStore} from '@modules/whiteboard'

export class WhiteboardPageStore {
  constructor(public page: WhiteboardPage, public tldraw: WhiteboardStore) {}

  @computed get pageIndex() { return this.tldraw.pagesInOrder.indexOf(this.page)}

  @computed get shapesByType(): { [type: string]: Array<WhiteboardShape> } {
    return _.groupBy(this.shapes, s => s.type)
  }

  @computed get shapes(): Array<WhiteboardShape> {
    return _.values(this.page.shapes)
  }

  @computed get shapesInOrder(): Array<WhiteboardShape> {
    return _.orderBy(this.shapes, s => s.childIndex)
  }

  @computed get pageState() {
    const {page: {id}, tldraw: {settings: {pages}}} = this
    return pages[id].state
  }

  isShapeSelected = (shape: TDShape) => {
    if (this.tldraw.currentPageWrapper != this) return false

  }

  get selectedIds() { return this.pageState?.selectedIds ?? []}

  @computed get selectedShapes(): Array<WhiteboardShape> {
    const {selectedIds, page: {shapes}} = this
    return selectedIds.map(id => shapes[id]).filter(_.identity)
  }

  get isCurrentPage() { return this === this.tldraw.currentPageWrapper}

  @action selectShape = (shape: TDShape) => {
    const {pageState, isCurrentPage, tldraw: {camera}} = this
    pageState.selectedIds = [shape.id]
    if (isCurrentPage) {
      camera.zoomToSelection(camera.zoom)
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/whiteboard/WhiteboardPageStore.ts